module.exports = __webpack_public_path__ + "img/my-object.a3c5cc32.png";